module.exports = __webpack_public_path__ + "media/images/winner--right-64b04a53a88b68bd40434ac77fe7eb35.png";